// extracted by mini-css-extract-plugin
export var darkMode = "_1d-0";